"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let CopyRoleDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.roleName = "";
    this.roleId = "";
    this.newRoleName = "";
    this.roleDescription = "";
  }
  open(data) {
    return __async(this, null, function* () {
      console.log(data);
      this.roleName = data.name;
      this.roleId = data.guid;
      this.dialog.visible = true;
    });
  }
  cancelCopy() {
    this.dialog.visible = false;
    this.roleName = "";
    this.roleId = "";
    this.newRoleName = "";
    this.roleDescription = "";
  }
  copyRole() {
    return __async(this, null, function* () {
      try {
        if (this.newRoleName.trim() === "" || this.newRoleName === null) {
          this.$message.error(this.$t("copy_role_dialog.error_new_role_name").toString());
          return;
        }
        yield API.post(`api://base.auth/api/v1/roles/${this.roleId}/copy`, {
          name: this.newRoleName,
          sourceRoleGuid: this.roleId,
          description: this.roleDescription
        });
        this.$message.success(this.$t("copy_role_dialog.success_copy_role").toString());
        this.cancelCopy();
        this.$emit("copyRoleSuccess");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
CopyRoleDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], CopyRoleDialog);
export {
  CopyRoleDialog as default
};
